<template>
<div class="login">
  <div class="main-inner">
    <main>
      <!-- .radius-box.white-box.row -->
      <section class="radius-box white-box row">
        <h2 class="login-pagetitle">法人会員専用 管理画面<br>ログイン</h2>
        <form action="/">
          <ul class="login-form">
            <li>
              <input type="text" name="email" v-model="loginForm.email" placeholder="メールアドレス">
              <div v-if="submitted && !$v.loginForm.email.required" class="text-error util-line-height-none"><small>メールアドレスを入力してください。</small></div>
            </li>
            <li>
              <input :type="inputType" name="password" v-model="loginForm.password" placeholder="パスワード" class="input">
              <span class="input-icon">
                <span :class="iconType" @click="onClick"><img class="password-icon" src="../../../static/icon_login.png"></span>
              </span>
              <div v-if="submitted && !$v.loginForm.password.required" class="text-error util-line-height-none"><small style="line-height:2.3;">パスワードを入力してください。</small></div>
            </li>
            <li v-if="displayErrorMessage" class="text-error"><div><small>{{ errorMessage }}</small></div></li>
            <li class="btn-gray2"><button @click.prevent="loginBtnClick">ログイン</button></li>
            <li><a href="/corp_admin/reset-password" class="arrow-text">パスワードをお忘れですか？</a></li>
          </ul>
        </form>
      </section>
    </main>
  </div>
</div>
</template>

<script>
import httpResource from '../../http/httpResource'
import router from '../../router/index'
import { required } from 'vuelidate/lib/validators'
import NewsSection from '@/components/NewsSection.vue'
import { mapActions } from 'vuex'
export default {
  name: 'Login',
  components: {
    NewsSection
  },
  data () {
    return {
      msg: 'login_index',
      loginForm: {
        email: '',
        password: ''
      },
      isChecked: false,
      loginInProcess: false,
      submitted: false,
      displayErrorMessage: false,
      errorMessage: '入力されたメールアドレスまたはパスワードが見つかりません。'
    }
  },
  validations: {
    loginForm: {
      email: {
        required
      },
      password: {
        required
      }
    }
  },
  beforeCreate: function () {
    document.body.className = 'login'
  },
  beforeDestroy: function () {
    document.body.classList.remove('login')
  },
  computed: {
    inputType: function () {
      return this.isChecked ? 'text' : 'password'
    },
    iconType: function () {
      return this.isChecked ? 'eye' : 'eye-slash'
    }
  },
  methods: {
    ...mapActions([
      'login',
      'updateCorporation',
      'updateSectors',
      'checkAdjournment'
    ]),
    onClick () {
      this.isChecked = !this.isChecked
    },
    async loginBtnClick () {
      this.submitted = true
      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.loginInProcess = true
      let canNavigate = false
      const loginRequestForm = {
        email: this.loginForm.email,
        password: this.loginForm.password
      }
      try {
        const response = await httpResource.post('/corporation/login', loginRequestForm)
        if (response.status === 200) {
          const payload = response.data
          this.login(payload.token)
          this.updateCorporation(payload.corporation)
          this.updateSectors(payload.sectors)
          // 休会状態の判断
          this.checkAdjournment(payload.incompleteTransferCorporation)
          canNavigate = true
        }
      } catch (error) {
        this.displayErrorMessage = true
      }
      this.loginInProcess = false
      if (canNavigate) {
        router.replace('/corp_admin/user')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/login/index.vue